import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material'
import { InsuranceProduct } from './insurance.types'

type InsuranceCardProps = {
  product: InsuranceProduct
  onDetails: (product: InsuranceProduct) => void
  onSimulate: (product: InsuranceProduct) => void
}

export function InsuranceCard({
  product,
  onDetails,
  onSimulate,
}: InsuranceCardProps) {
  return (
    <Card
      variant="outlined"
      sx={{
        p: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'box-shadow 150ms ease, transform 150ms ease',
        '&:hover': {
          boxShadow: 3,
          transform: 'translateY(-2px)',
        },
      }}
    >
      <CardActionArea
        onClick={() => onDetails(product)}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        }}
      >
        <CardMedia
          component="img"
          height="150"
          image={product.image}
          alt={product.imageAlt}
          sx={{ objectFit: 'cover' }}
        />
        <CardContent sx={{ flex: 1, width: '100%' }}>
          <Typography variant="h6" gutterBottom>
            {product.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {product.subtitle}
          </Typography>
        </CardContent>
      </CardActionArea>

      <CardActions sx={{ p: 2, pt: 0, gap: 1 }}>
        <Button
          variant="outlined"
          size="small"
          fullWidth
          onClick={() => onDetails(product)}
        >
          Saiba mais
        </Button>
        <Button size="small" fullWidth onClick={() => onSimulate(product)}>
          Simular
        </Button>
      </CardActions>
    </Card>
  )
}
